import { useEffect, useState } from "react";

import Button from "../common/button";
import HintModal from "../common/hint-modal";

import useGetCollabEdit, { useSaveCollabEdit } from "./useCollabEdit";

const CollabEditing = () => {
  // const heading = "FIRM SETTINGS TITLE WITH CENTERED TEXT";
  const points = [
    "Firm settings panel instruction point one",
    "Firm settings panel instruction point two",
    "Firm settings panel instruction point three",
  ];
  const [shakespareState, setShakespareState] = useState();

  const handleShakespareState = (e) => {
    setShakespareState(e.target.value);
  };

  const { data, refetch } = useGetCollabEdit();
  const { saveCollabEdit } = useSaveCollabEdit();
  const shakespareVal = [
    { value: "On", name: "On" },
    { value: "Off", name: "Off" },
  ];
  const [showHints, setShowHints] = useState(false);

  const handleHintToggle = () => {
    setShowHints(!showHints);
  };

  useEffect(() => {
    if (data && data?.enabled) {
      setShakespareState("On");
    } else {
      setShakespareState("Off");
    }
  }, [data]);
  return (
    <div className="tab-pane fade firm-settings-user-perms-fs active show">
      <div className="d-flex justify-content-between">
        <h3 className="mb-3">Collaboration Settings</h3>
        <div
          className="d-flex justify-content-end m-b-5"
          onClick={() => {
            handleHintToggle();
          }}
        >
          <i className="ic ic-19 ic-help-2 cursor-pointer" />
        </div>
      </div>
      <div className="m-b-5">
        <div
          className="d-flex custom-select-new-provider"
          style={{
            maxWidth: "300px",
            top: "0px",
          }}
        >
          <label className="text-nowrap me-2">Collaborative Editing Status:</label>
          <select
            className="form-control m-r-5 height-25 p-l-5 py-0 "
            value={shakespareState}
            disabled={!data?.can_manage}
            // style={{
            //   maxWidth: "200px",
            // }}
            onChange={handleShakespareState}
          >
            <option value="">Select Collaborative Editing Status</option>
            {shakespareVal.map((status) => (
              <option key={status.value} value={status.value}>
                {status.name}
              </option>
            ))}
          </select>
        </div>
        <Button
          text={"Save"}
          className={"btn-success height-25 d-flex align-items-center"}
          disabled={!data?.can_manage}
          onClick={async () => {
            await saveCollabEdit({
              enabled: shakespareState === "On" ? true : false,
            });
            refetch();
          }}
        />
      </div>
      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
    </div>
  );
};

export default CollabEditing;
